import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker desactivado temporalmente para limpiar caches problemáticos
// Se reactivará cuando el PWA esté estabilizado
serviceWorkerRegistration.unregister();
